import { render, staticRenderFns } from "./CustomerStatement.vue?vue&type=template&id=3ad87aca&scoped=true"
import script from "./CustomerStatement.vue?vue&type=script&lang=js"
export * from "./CustomerStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad87aca",
  null
  
)

export default component.exports